import { RichTextRenderer } from '@/components/rich-text/rich-text-renderer';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { dataTestTransformer } from '@/utils/data-test-helper';
import { Attribute } from '@cinemark/content-api-client';
import Image from 'next/image';
import { ReactNode, useState } from 'react';

type AttributeModalProps = {
  attribute: Attribute;
  children: ReactNode;
};

export const AttributeModal = ({ attribute, children }: AttributeModalProps): React.JSX.Element => {
  const [open, setOpen] = useState(false);
  const attributeName = attribute?.contentPage?.headline?.trim() || 'Attribute details';
  const attributeSlug = dataTestTransformer(attributeName);
  const bannerImageUrl = attribute?.contentPage?.bannerImage?.url?.trim();
  const imageToDisplay = attribute?.contentPage?.bannerImage
  && bannerImageUrl
  && !bannerImageUrl.includes('poster_blank.jpg')
    ? attribute.contentPage.bannerImage : undefined;

  return (
    <Dialog open={open}
      onOpenChange={setOpen}
    >
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>

      <DialogContent className="max-w-[400px] md:max-w-[470px]">
        <DialogHeader>
          <DialogTitle className="text-lg"
            data-test={`attribute-title-${attributeSlug}`}
          >{attributeName}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {attributeName} details
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-4 items-center text-center">
          {imageToDisplay &&
          <div className="flex w-full justify-center">
            <Image alt={attribute.imageAltText?.trim() || attributeName}
              className="h-auto max-w-full"
              height={imageToDisplay.height || 200}
              src={imageToDisplay.url || ''}
              width={imageToDisplay.width || 200}
            />
          </div>
          }

          {attribute?.contentPage?.sidebarText &&
            <div className="[&_p]:text-sm text-left"
              data-test={`attribute-description-${attributeSlug}`}
            >
              <RichTextRenderer content={attribute.contentPage.sidebarText}/>
            </div>
          }
        </div>
      </DialogContent>
    </Dialog>
  );
};
